export enum WebsocketType {
  ChannelArchive = 'channelArchive',
  Channel = 'channel',
  ChannelDisplay = 'channelDisplay',
  ChannelPreference = 'channelPreference',
  ChannelTranslate = 'channelTranslate',
  ChannelLog = 'channelLog',
  ChannelAdmin = 'channelAdmin',
  ChannelManagement = 'channelManagement',
  ChannelMember = 'channelMember',
  ChannelMemberReadSeq = 'channelMemberReadSeq',
  ChannelNotice = 'channelNotice',
  ChannelFavorite = 'channelFavorite',
  ChannelFavoriteName = 'channelFavoriteName',
  ChannelFavoriteOrder = 'channelFavoriteOrder',
  ChannelMemberLang = 'channelMemberLang',

  MemberPreference = 'memberPreference',
  MemberStatus = 'memberStatus',
  Member = 'member',

  StreamPush = 'streamPush',

  ToastContinuous = 'toastContinuous',
  Server = 'server',
  WebsocketNotify = 'websocketNotify',
  WebSocketClose = 'WebSocketClose',

  Dialog = 'dialog',
}

export enum WebsocketChannelArchiveAction {
  On = 'on',
  Off = 'off',
}

export enum WebsocketChannelAction {
  Create = 'create',
  Update = 'update',
}

export enum WebsocketChannelDisplayAction {
  On = 'on',
  Off = 'off',
}

export enum WebsocketChannelPreferenceAction {
  Update = 'update',
}

export enum WebsocketChannelTranslateAction {
  Update = 'update',
}

export enum WebsocketChannelLogAction {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}

export enum WebsocketMemberStatusAction {
  Local = 'local',
  Update = 'update',

  // upstream 전용
  PEEK = 'peek',
  SUBSCRIBE = 'subscribe',
  UNSUBSCRIBE = 'unsubscribe',
}

export enum WebsocketMemberAction {
  Update = 'update',
  Withdraw = 'withdraw',
}

export enum WebsocketChannelAdminAction {
  Register = 'register',
  Remove = 'remove',
}

export enum WebsocketChannelManagementAction {
  Update = 'update',
}

export enum WebsocketChannelMemberAction {
  Join = 'join',
  Leave = 'leave',
  Remove = 'remove',
}

export enum WebsocketChannelMemberReadSeqAction {
  Update = 'update',
}

export enum WebsocketChannelNoticeAction {
  Topped = 'topped',
  Untopped = 'untopped',
}

export enum WebsocketChannelFavoriteAction {
  Create = 'create',
  Remove = 'remove',
}

export enum WebsocketChannelFavoriteNameAction {
  Update = 'update',
}

export enum WebsocketChannelFavoriteOrderAction {
  Update = 'update',
}

export enum WebsocketChannelMemberLangAction {
  Update = 'update',
}

export enum WebsocketMemberPreferenceAction {
  Update = 'update',
}

export enum WebsocketStreamPushAction {
  Update = 'update',
}

export enum WebsocketToastContinuousAction {
  Display = 'display',
}

export enum WebsocketServerAction {
  Upgrade = 'upgrade',
}

export enum WebSocketCloseAction {
  ConnectSameSessionKey = 'connectSameSessionKey',
}

export enum WebsocketNotifyAction {
  Disconnection = 'disconnection',
}

export enum WebsocketDialogAction {
  Open = 'open',
}

export type WebsocketAction = WebsocketChannelArchiveAction &
  WebsocketChannelAction &
  WebsocketChannelDisplayAction &
  WebsocketChannelPreferenceAction &
  WebsocketChannelTranslateAction &
  WebsocketChannelLogAction &
  WebsocketMemberStatusAction &
  WebsocketMemberAction &
  WebsocketChannelAdminAction &
  WebsocketChannelManagementAction &
  WebsocketChannelMemberAction &
  WebsocketChannelMemberReadSeqAction &
  WebsocketChannelNoticeAction &
  WebsocketChannelFavoriteAction &
  WebsocketChannelFavoriteNameAction &
  WebsocketChannelFavoriteOrderAction &
  WebsocketChannelMemberLangAction &
  WebsocketMemberPreferenceAction &
  WebsocketStreamPushAction &
  WebsocketToastContinuousAction &
  WebsocketServerAction &
  WebSocketCloseAction &
  WebsocketNotifyAction &
  WebsocketDialogAction;
